<template>
          
    <div class="vertFlex tclass">
        <div class="horizFlexStretch bottomborder">
            <label class="  " for > {{getGuestName}}</label>
            <label class="  " for > {{ticket.employeeName}}</label>
            <!-- <label class=" " for>{{toDate(ticket.startDateTime)}}</label> -->
            
        </div>
        
        <!-- if we have prep areas, divide by them -->
        <div v-if="usingPrepAreas" class="margintop">
            <div v-for="pa in prepAreas" :key="pa.id" :value="pa.id" class="" >
                <div v-if="areaHasItems(pa.name)">
                    <label class="bold " >{{pa.name}}</label>
                    <div v-for="li in lineItemsByArea(pa.name)" :key="li.id" :value="li.id" class="tliclass indentsmall" >
                        <label class="lineitemlabel " for>{{getProductString(li)}}</label>
                        <div class="indent">
                            <label class="lineitemlabel " for>{{li.optionNote}}</label>
                        </div>
                        
                    </div>
                </div>
                
                
            </div>
            <label class="bold " >Other</label>
            <div v-for="li in lineItemsByArea(null)" :key="li.id" :value="li.id" class="tliclass indentsmall" >
                <label class="lineitemlabel " for>{{getProductString(li)}}</label>
                <div class="indent">
                    <label class="lineitemlabel " for>{{li.optionNote}}</label>
                </div>
            </div>
        </div>


        <div v-for="li in ticket.lineItems" :key="li.id" :value="li.id" class="tliclass" v-if="!usingPrepAreas">
            <label class="lineitemlabel " for>{{getProductString(li)}}</label>
            <div class="indent">
                <label class="lineitemlabel " for>{{li.optionNote}}</label>
            </div>
            
        </div>


        <div class="vertFlex totaldiv ">
            <label for class=" totallabel">Subtotal: {{ ticket.subTotal|toCurrency }}</label>
            <label for class=" totallabel discountcolor">Discount: {{ ticket.discountAmount|toCurrency }}</label>
            <label for class=" totallabel">Tax: {{ ticket.tax|toCurrency }}</label>
            <label for class=" totallabel">Total: {{ ticket.total|toCurrency }}</label>
        </div>
                    

                    
        <div class="tliclass" v-for="pi in ticket.paymentItems" :key="pi.id" :value="pi.id"  >
            <div class="horizFlexStretch">
                <p class="leftjustified">{{ pi.typeName }}</p>
                <p class="leftjustified">{{ pi.numberData }}</p>
                <p class="rightjustified">{{amount(pi)}}</p>
            </div>
            
        </div>
    </div>
                            
</template>
    
    <script>
    import format from '../../style/format.js'
    export default {
        name:'ticketv',
        
        props:{
           
            ticket:{
                type:Object,
                default:null
            },
            prepAreas:{
                type:Array,
                default:[]
            }
            
        },
        mixins:[format],
       
        data(){
            return{
              
            }
        },
        computed:{
            usingPrepAreas(){
                return this.prepAreas.length>0
            },
            getGuestName(){
                var name=null
                //console.log('gname ' + this.ticket.guestName)
                if(this.ticket.TakeOutGuestName!=null){return this.ticket.TakeOutGuestName}
                else if(this.ticket.guestName!=null && !this.ticket.guestName.includes('T:')){name= this.ticket.guestName}
                
                if(this.ticket.TableNumber!=null){
                    if(this.ticket.TableNumber>0){
                        if(name==null){name='Table ' + this.ticket.TableNumber} 
                        else{name = name + '/' + 'Table ' + this.ticket.TableNumber}
                    }
                    
                }
                return name
            }
        },
        methods:{
            lineItemsByArea(pa){
                var items=[]
                this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    //console.log('pstring ' + li.productPrepAreaString)
                    if(li.productPrepAreaString==null ){
                        if( pa==null){items.push(li)} 
                    }
                    else if(li.productPrepAreaString.includes(pa) ){
                        items.push(li)
                    }
                    
                } 
                return items
            },
            areaHasItems(pa){
                console.log(pa)
                var hasitems=false
                this.ticket.lineItems.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let li=arr[index]
                    if(li.productPrepAreaString!=null){
                        if(li.productPrepAreaString.includes(pa) ){
                            hasitems=true
                        }
                    }
                    
                } 
                return hasitems
            },
            getProductString(li){
                var pstring = li.quantity + ' ' + li.productName
                /* if(li.productPrepAreaString!=null){
                    pstring = pstring + " (" + li.productPrepAreaString + ")"
                } */
                return pstring
            },
            amount(pi){
                var amt = pi.amount
                if(pi.changeGiven>0){
                     amt = pi.amount - pi.changeGiven
                }
                return this.$options.filters.toCurrency(amt)
            },
            toDate(dt){
                return this.$options.filters.formatTime_NoSeconds(dt);
            },
            
        
            tclass(g){
                let c = "tclass"
                return c
            },
            
          
                
        }
    }
    
    </script>
    
    <style>
    .indent{
        margin-left: 10px;
        font-size: smaller;
    }
    .indentsmall{
        margin-left: 5px;
    }
    .tclass{
        font-size:medium;
        width:200px;
        margin:5px;
        border:1px solid gray;
        text-align:left;
        padding:5px;
        border-radius:5px;
    }
    .tliclass{
        /* border-bottom:1px solid lightgray; */
        text-align:left;
        padding:10px 0px 10px 0px;
 
    }
    .bottomborder{
        border-bottom:1px solid gray;
        
    }
    .lineitemlabel{
      
    }
    .totaldiv{
        padding-top:5px;
        border-top:1px solid gray;
    }
    .totallabel{
        text-align: right;
        
    
    }
    
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    